import { Component, computed, inject, input } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import type { OnyxIconName } from '@onyx/angular';
import {
  ONYX_TABLE_TOOLTIP_DELAY,
  OnyxIconComponent,
  OnyxTooltipDirective,
} from '@onyx/angular';
import { DictionaryCode } from '../../../../../../common/enums/dictionary-code';
import { OrderSemiTrailerSize } from '../../../enums/order-semi-trailer-size';

@Component({
  selector: 'app-order-semi-trailer-size-cell',
  imports: [OnyxIconComponent, OnyxTooltipDirective],
  templateUrl: './order-semi-trailer-size-cell.component.html',
  styleUrl: './order-semi-trailer-size-cell.component.scss',
})
export class OrderSemiTrailerSizeCellComponent {
  private readonly translateService = inject(TranslateService);

  public readonly semiTrailerSize = input.required<OrderSemiTrailerSize>();

  protected readonly I18N = 'orders.ordersList.cells';
  protected readonly TOOLTIP_DELAY = ONYX_TABLE_TOOLTIP_DELAY;

  protected iconName = computed<OnyxIconName>(() => {
    const trailerSize = this.semiTrailerSize();
    return trailerSize === OrderSemiTrailerSize.AUTO
      ? 'refresh-outlined'
      : `semi-trailer-${trailerSize}-outlined`;
  });

  protected tooltipContent = computed(() => {
    const trailerSize = this.semiTrailerSize();
    return trailerSize === OrderSemiTrailerSize.AUTO
      ? this.translateService.instant(`${this.I18N}.anySemiTrailerSize`)
      : this.translateService.instant(`${this.I18N}.minSemiTrailerSize`, {
          size: this.translateService.instant(
            `${DictionaryCode.ORDER_SEMI_TRAILER_SIZE}.${trailerSize}`,
          ),
        });
  });
}
